import {
  createIntrospection,
  createNotification,
  sendEmailToPolaznikMentor,
  updateIntrospection,
  updateNotify,
} from "../../pojediniProgrami/SectionContainer/API";
import { fetchData } from "../../pojediniProgrami/SectionContainer/utils";

export const handleSaveClick = async ({
  setIsLoading,
  inputValue,
  minCommentSize,
  handleCommentsUpdate,
  isCommentDone,
  isMentorRole,
  polaznikId,
  mentorData,
  userData,
  introspectionNumber,
  authToken,
  introspectionData,
  introspectionId,
  setIntrospectionData,
  setIsReal,
  setDbComment,
  setIsNotifyModalOpen,
  setIsNotify,
  setIsErrorModalOpen,
  setShowEditComment,
  setInputValue,
  comments,
  selectedGroup,
  title,
  emailAddressPolaznik,
}) => {
  setIsLoading(true);
  console.log(selectedGroup);
  try {
    let commentLength = inputValue
      ?.replace(/[.,/#!$%^&*;:{}=\-_`~()?]/g, "")
      .replace(/\s/g, "").length;
    if (commentLength >= minCommentSize) {
      await handleCommentsUpdate(inputValue, isCommentDone);
      await handleNotify({
        isMentorRole,
        polaznikId,
        mentorData,
        userData,
        introspectionNumber,
        setIsLoading,
        authToken,
        introspectionData,
        introspectionId,
        setIntrospectionData,
        setIsReal,
        setDbComment,
        setIsNotifyModalOpen,
        setIsNotify,
        setIsErrorModalOpen,
        selectedGroup,
        title,
        emailAddressPolaznik: emailAddressPolaznik,
      });
      setShowEditComment(false);
    } else {
      await handleCommentsUpdate(inputValue, false);
    }
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
    console.error(error);
  }
  setShowEditComment(false);
  setInputValue(comments || "");
};

export const handleNotify = async ({
  isMentorRole,
  polaznikId,
  mentorData,
  userData,
  introspectionNumber,
  setIsLoading,
  authToken,
  introspectionData,
  introspectionId,
  setIntrospectionData,
  setIsReal,
  setDbComment,
  setIsNotifyModalOpen,
  setIsNotify,
  setIsErrorModalOpen,
  emailAddressPolaznik,
  selectedGroup,
  title,
}) => {
  let notificationData = {
    primatelj: isMentorRole ? polaznikId : mentorData?.id,
    subject: isMentorRole
      ? "Introspekcija pregledana"
      : `Introspekcija ${userData.firstName} ${userData.lastName}`,
    description: isMentorRole
      ? `Introspekcija ${introspectionNumber}. je pregledana i komentirana. Kliknite na <a href="/introspekcije-polaznik/${introspectionId}" target:"_blank">link</a> da biste ju pregledali.`
      : `Polaznik je poslao introspekciju ${introspectionNumber} (${title}). Kliknite na <a href="/voditelj-moja-mentorstva/${selectedGroup}" target:"_blank">link</a> da biste ju   pregledali.`,
    userId: userData.id,
    groupId: selectedGroup ? selectedGroup : null,
    introspectionId: introspectionId ? introspectionId : null,
  };
  setIsLoading(true);
  console.log(isMentorRole ? emailAddressPolaznik : mentorData?.emailAddress);
  const response = await createNotification(notificationData, authToken);
  if (response.status === 200) {
    if (mentorData) {
      await updateNotify(
        { ...introspectionData.userInIntrospection, isNotifyAllowed: false },
        authToken
      );
    }
    fetchData(
      introspectionId,
      authToken,
      setIntrospectionData,
      setIsReal,
      setDbComment,
      setIsLoading
    );
    setIsNotifyModalOpen(true);
    setIsLoading(false);
    setIsNotifyModalOpen(true);
    await sendEmailToPolaznikMentor({
      ...notificationData,
      emailTo: isMentorRole ? emailAddressPolaznik : mentorData?.emailAddress,
    });
  } else {
    setIsNotify(true);
    setIsErrorModalOpen(true);
  }
};

export const handleUpdate = async ({
  introspectionId,
  dbComment,
  comments,
  userAnswer,
  isMentorRole,
  polaznikId,
  userData,
  isDone,
  isReal,
  authToken,
  setIsErrorModalOpen,
  setIsReal,
  setIntrospectionData,
  setDbComment,
  setIsLoading,
}) => {
  const newIntrospectionsData = {
    introspectionId: introspectionId,
    mentorComment: dbComment || comments || "",
    userAnswer: userAnswer,
    userId: isMentorRole ? polaznikId : userData.id,
    isDone: isDone,
    isRead: !(dbComment === "" || comments === ""),
  };
  let response;
  if (!isReal && !isMentorRole) {
    response = await createIntrospection(newIntrospectionsData, authToken);
    if (response.status === 200) {
      fetchData(
        introspectionId,
        authToken,
        setIntrospectionData,
        setIsReal,
        setDbComment,
        setIsLoading
      );
    }
    if (!response?.data?.introspectionId && !isMentorRole) {
      setIsErrorModalOpen(true);
      return;
    }
    setIsReal(true);
  } else {
    response = await updateIntrospection(newIntrospectionsData, authToken);
    if (response[0] === 1) {
      fetchData(
        introspectionId,
        authToken,
        setIntrospectionData,
        setIsReal,
        setDbComment,
        setIsLoading
      );
    }
    if (response[0] !== 1) {
      setIsErrorModalOpen(true);
      return;
    }
  }
};
